var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 28.5,
    fill: "#11AB1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20V44M28 20H22.6964C21.915 20 21.1656 19.6839 20.613 19.1213C20.0604 18.5587 19.75 17.7956 19.75 17C19.75 16.2044 20.0604 15.4413 20.613 14.8787C21.1656 14.3161 21.915 14 22.6964 14C26.8214 14 28 20 28 20ZM28 20H33.3036C34.085 20 34.8344 19.6839 35.387 19.1213C35.9396 18.5587 36.25 17.7956 36.25 17C36.25 16.2044 35.9396 15.4413 35.387 14.8787C34.8344 14.3161 34.085 14 33.3036 14C29.1786 14 28 20 28 20ZM40 27.5V39.2C40 40.8802 40 41.7202 39.673 42.362C39.3854 42.9265 38.9265 43.3854 38.362 43.673C37.7202 44 36.8802 44 35.2 44L20.8 44C19.1198 44 18.2798 44 17.638 43.673C17.0735 43.3854 16.6146 42.9265 16.327 42.362C16 41.7202 16 40.8802 16 39.2V27.5M13 22.4L13 25.1C13 25.9401 13 26.3601 13.1635 26.681C13.3073 26.9632 13.5368 27.1927 13.819 27.3365C14.1399 27.5 14.5599 27.5 15.4 27.5L40.6 27.5C41.4401 27.5 41.8601 27.5 42.181 27.3365C42.4632 27.1927 42.6927 26.9632 42.8365 26.681C43 26.3601 43 25.9401 43 25.1V22.4C43 21.5599 43 21.1399 42.8365 20.819C42.6927 20.5368 42.4632 20.3073 42.181 20.1635C41.8601 20 41.4401 20 40.6 20L15.4 20C14.5599 20 14.1399 20 13.819 20.1635C13.5368 20.3073 13.3073 20.5368 13.1635 20.819C13 21.1399 13 21.5599 13 22.4Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift_icon.f8e8a01e8d164b1c3941f9372261910b.svg";
export { ForwardRef as ReactComponent };